'use client';

import { Description, Title } from '@radix-ui/react-toast';

import { CloseOutlined, InfoOutlined } from '@lichtblick/icons';
import { Colors, TextVariants } from '@lichtblick/theme';

import { BannerRoot, CloseButton, ToastRoot, Wrapper } from './Snackbar.styles';

import { Text } from '../Text';

type SnackbarProps = {
  color?: 'black' | 'white';
  isOpen?: boolean;
  message: string;
  setOpen?: (input: boolean) => void;
  title: string;
  variant?: 'default' | 'banner';
};

export const Snackbar = ({
  color = 'black',
  isOpen = true,
  message,
  setOpen,
  title,
  variant = 'default',
}: SnackbarProps) => {
  if (!isOpen) {
    return null;
  }

  if (variant === 'banner') {
    return (
      <BannerRoot data-testid="snackbar" data-variant="banner">
        <InfoOutlined sx={{ color: Colors.red['100'], transform: 'rotate(180deg)' }} />
        <Wrapper>
          <Text $variant={TextVariants.header.s} color={Colors.red['100']}>
            {title}
          </Text>
          <Text $variant={TextVariants.body.l} color={Colors.red['100']}>
            {message}
          </Text>
        </Wrapper>
        <CloseButton asChild onClick={() => setOpen?.(false)}>
          <CloseOutlined sx={{ color: Colors.red['100'] }} />
        </CloseButton>
      </BannerRoot>
    );
  }

  return (
    <ToastRoot
      $color={color}
      data-testid="snackbar"
      duration={100}
      onOpenChange={() => setTimeout(() => setOpen?.(false), 3000)}
      open={isOpen}
    >
      <InfoOutlined sx={{ color: color === 'black' ? Colors.white : Colors.black, transform: 'rotate(180deg)' }} />
      <Wrapper>
        <Title className="snackbar-message">
          <Text $variant={TextVariants.header.s} color={color === 'black' ? Colors.white : Colors.black}>
            {title}
          </Text>
        </Title>
        <Description className="snackbar-close">
          <Text $variant={TextVariants.body.l} color={color === 'black' ? Colors.white : Colors.black}>
            {message}
          </Text>
        </Description>
      </Wrapper>
      <CloseButton asChild onClick={() => setOpen?.(false)}>
        <CloseOutlined sx={{ color: color === 'black' ? Colors.white : Colors.black }} />
      </CloseButton>
    </ToastRoot>
  );
};
